import Repository from './repository';


export default (token) => {
  const resource = 'hp-settings';
  const { index } = Repository(resource, token);
  return { index };
};
